import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import {
    BlockType,
    CodeBlock,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as simulator from './simulator';
import * as tios from './tios';

export default class Tibbit_29 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_29';
        this.name = 'Tibbit 29';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt29/tbt29.tbh',
            'libraries/tibbits/tbt29/tbt29.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'TEMP_NAME',
                name: 'Temperature Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
